<zef-dialog
  [open]="state.open"
  [autoFocus]="false"
  (closeTrigger)="onCloseDialog$.next()">
  <div class="__content">

    @if (state.addon; as addon) {

      <h3 class="__title">
        {{ addon.unitPrice === 0 ? state.translations?.reuseTitle : state.translations?.activateTitle }}
      </h3>

      <p class="__desc">
        {{ state.translations?.projectPrefix }} <strong>{{ addon.projectName }}</strong>
        {{ addon.unitPrice === 0 ? state.translations?.reuseDesc : state.translations?.activateDesc }}
      </p>

      <p class="__price">
        <strong class="__price-amount">{{ addon.unitPrice === 0 ? 'No extra charge' : '$' + addon.unitPrice + ' per month' }}</strong>
        <span class="__price-period">
          {{ addon.validFrom | date: 'mediumDate' }} &ndash; {{ addon.validTill | date: 'mediumDate' }}, renews monthly
        </span>
      </p>

      @if (state.canAfford === false) {
        <div class="__credit-warning">

          {{ state.translations?.creditWarning }}

          @if (!state.isContabo && state.canEditFinances) {
            <button
              class="__topup-button  c-button--smaller"
              type="button"
              (click)="onOpenTopUpDialog$.next(); onCloseDialog$.next();"
              mat-flat-button>
              <mat-icon>add_circle_outline</mat-icon>
              Top up credit
            </button>
          }

        </div>
      }

    }

    @if (state.subscription; as subscription) {

      <h3 class="__title">{{ state.translations?.releaseTitle }}</h3>

      <p class="__desc">
        {{ state.translations?.releaseDesc }} <strong>{{ subscription.projectName }}</strong> {{ state.translations?.releaseDescSuffix }}
        {{ key + '.releaseReuseDesc' | transloco: { validTill: (subscription.validTill | date: 'mediumDate') } }}
      </p>

    }

    <div class="__buttons-grid">

      <div
        [matTooltip]="state.requestIpV4DisabledReason"
        [matTooltipDisabled]="!state.addon || !state.requestIpV4DisabledReason">
        <zef-progress-error
          full
          [key]="loadingKeys"
          [disabled]="!!state.addon && (!state.canAfford || !!state.requestIpV4DisabledReason)">
          <button
            class="c-button--full"
            mat-flat-button
            [color]="!!state.subscription ? 'warn' : 'accent'"
            [disabled]="!!state.addon && (!state.canAfford || !!state.requestIpV4DisabledReason)"
            type="button"
            (click)="!!state.addon ? onActivate$.next() : onRelease$.next()">
            @if (!!state.addon) {
              {{ ipV4AddonButtonText(state.addon) }}
            } @else {
              {{ state.translations?.releaseIpV4 }}
            }
          </button>
        </zef-progress-error>
      </div>

      <button
        class="c-button--full"
        type="button"
        (click)="onCloseDialog$.next()"
        mat-button>
        {{ state.translations.close }}
      </button>

    </div>

  </div>
</zef-dialog>
